var Star2 = "/static/a61d702051569edf.png";

export { Star2 as default };
//# sourceMappingURL=star-2.png.js.map
